import { FC, useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { RouteComponentProps } from 'react-router-dom';
import styled from 'styled-components';
import Button from '../../components/common/Button';
import Footer from '../../components/Footer';
import HeaderOLD from '../../components/OLD_Header';
import ImageTape from '../../components/ImageTape';

const Style = styled.div`
  height: 100vh;

  .h-header {
    padding: 16px;
  }

  .tu-flexer {
    display: flex;
    height: 100%;
    flex-direction: column;
    justify-content: space-between;

    .tu-main {
      flex-grow: 1;
    }
  }
`;

const ThankYou: FC<RouteComponentProps> = ({ history, match }) => {
  const { t } = useTranslation();

  const text = useMemo(() => {
    if (match.url.includes('signup')) {
      return t('pages.thankYou.weAppreciateYouSigningUp');
    } else if (match.url.includes('survey')) {
      return t('pages.thankYou.weAppreciateYouTakingTheTime');
    }

    return '';
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  /*
   * Scroll to top when pages change
   */
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Style>
        <HeaderOLD inverted />
        <div className="tu-flexer">
          <div className="tu-main container">
            <h1>
              {t('pages.thankYou.thankYou')} <i className="material-icons">favorite</i>
            </h1>
            <p>{text}</p>

            <Button onClick={() => history.replace('/')}>
              {t('pages.thankYou.checkOutTheRestaurants')}
            </Button>
          </div>

          <ImageTape />
        </div>
      </Style>
      <Footer />
    </>
  );
};

export default ThankYou;
